module.exports = __webpack_public_path__ + "img/combojetvac_driving.d5ab8ebb.svg";